import { SignalingSocket, SignalingTokenResponse } from 'services/signaling';
import { http } from 'utils/http';

export const exportChatService = async (roomId: string) => {
  const { token } = await SignalingSocket.sendAsync<SignalingTokenResponse>({
    event: 'requestDownloadToken',
    data: {
      type: 'chat',
    },
  });

  return http.get<Blob>(`/room-api/${roomId}/chat/export?format=zip`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob',
  });
};
